// extracted by mini-css-extract-plugin
export default {"edit-button":"EditButton-module__edit-button___gXI70"};